export default __webpack_public_path__ + "static/media/Welcome.bca61fc2.jpeg";